import { MeditatorTabs } from "@/constants";
import { Helmet } from 'react-helmet-async';
import { useLocation } from "react-router";
import { AnimatedComponent } from "../common";
import { MeditationRetreatsByLevel } from "../MeditationRetreats";
import { MeditatorFilter } from "./MeditatorFilter";
import { PendingNewRegistrants } from "./PendingNewRegistrants";

export function RegisteredMeditators() {
	const searchParams = useLocation().search;
	const activeTab = new URLSearchParams(searchParams).get("tab");

	const renderTabContent = () => {
		switch (activeTab) {
			case MeditatorTabs.registered_meditators:
				return <PendingNewRegistrants />;
			case MeditatorTabs.new_registrants:
				return (
					<MeditationRetreatsByLevel
						levelIds={[1]}
						hasFilter={false}
					/>
				);
			case MeditatorTabs.old_registrants:
				return <MeditationRetreatsByLevel levelIds={[2, 3, 4, 5]} />;
			default:
				return <PendingNewRegistrants />;
		}
	};

	const pageTitle = () => {
		switch (activeTab) {
			case MeditatorTabs.registered_meditators:
				return "စာရင်းသွင်းထားသောယောဂီများ";
			case MeditatorTabs.new_registrants:
				return "ယောဂီအသစ်စာရင်း";
			case MeditatorTabs.old_registrants:
				return "ယောဂီအဟောင်းစာရင်း";
			default:
				return "စာရင်းသွင်းထားသောယောဂီများ";
		}
	};

	return (
		<AnimatedComponent className="space-y-6">
			<Helmet>
				<title> {pageTitle()} </title>
			</Helmet>
			<MeditatorFilter />
			{renderTabContent()}
		</AnimatedComponent>
	);
}
